import React, { Component } from "react";

import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import { AddCircleOutline, RemoveCircleOutline } from "@material-ui/icons";
import QuantityBoxDialog from "./QuantityBoxDialog";
import { getProductInventory } from "../../../../store/reducers/store";
class ListQuantityBox extends Component {
  state = { openQuantityDialog: false };
  handleClick = (e, addedQuantity) => {
    const {
      option,
      choice,
      optionSelectedAmount,
      choiceSelectedAmount,
      productQuantity,
      usedComponents,
      productUsedComponents,
      editedProduct,
      groupID,
    } = this.props;
    e.stopPropagation();
    if (
      optionSelectedAmount + addedQuantity > (option.maximum || Infinity) ||
      choiceSelectedAmount + addedQuantity > (choice.maximum || Infinity)
    ) {
      return;
    }
    if (choice.related_product && choice.inventory !== null) {
      const totalUsedComponents = { ...usedComponents };
      Object.entries(editedProduct?.prevUsedComponents || {}).forEach(
        ([optionId, optionQuantity]) => {
          const newOptionId = optionId.toString().replace("Q", "");
          totalUsedComponents[newOptionId] =
            (totalUsedComponents[newOptionId] || 0) -
            optionQuantity *
              ((optionId.toString().includes("Q") && 1) ||
                editedProduct.quantity);
        }
      );
      Object.entries(productUsedComponents).forEach(
        ([productId, optionQuantity]) => {
          const newProductId = productId.toString().replace("Q", "");
          totalUsedComponents[newProductId] =
            (totalUsedComponents[newProductId] || 0) +
            optionQuantity *
              ((productId.toString().includes("Q") && 1) ||
                productQuantity.quantity);
        }
      );
      const choiceInventory = getProductInventory(
        choice.related_product,
        totalUsedComponents
      );
      if (
        choiceInventory <
        addedQuantity *
          ((option.quantity_exclusive && 1) || productQuantity.quantity)
      )
        return;
    }
    this.props.controlOptions(option, choice, addedQuantity, groupID);
  };
  openQuantityDialog = (e) => {
    e.stopPropagation();
    this.setState({ openQuantityDialog: true });
  };
  render() {
    const {
      option,
      choice,
      optionSelectedAmount,
      choiceSelectedAmount,
      controlOptions,
      themeColor,
      language,
      productQuantity,
      productUsedComponents,
      editedProduct,
      groupID,
    } = this.props;
    const { openQuantityDialog } = this.state;
    return (
      <Grid
        direction={language === "arabic" && "row-reverse"}
        className="mx-auto"
        alignItems="center"
        justify="space-around"
        container
        style={{
          width: this.props.option.layout !== "dense" ? 100 : 85,
          backgroundColor: "white",
          height: 30,
        }}
      >
        <Grid
          item
          onClick={(e) => this.handleClick(e, -1)}
          className="option-quantity-button"
        >
          <RemoveCircleOutline style={{ color: themeColor }} />
        </Grid>
        <Grid item onClick={this.openQuantityDialog}>
          {openQuantityDialog && (
            <QuantityBoxDialog
              closeModal={() => this.setState({ openQuantityDialog: false })}
              choiceSelectedAmount={choiceSelectedAmount}
              optionSelectedAmount={optionSelectedAmount}
              option={option}
              choice={choice}
              controlOptions={controlOptions}
              productQuantity={productQuantity}
              productUsedComponents={productUsedComponents}
              editedProduct={editedProduct}
              groupID={groupID}
            />
          )}
          <div
            className="text-center"
            style={{
              color: themeColor,
              border: "0.5px solid #DEDEDE",
              borderRadius: 5,
              width: 35,
              padding: 1,
              overflow: "hidden",
            }}
          >
            {choiceSelectedAmount}
          </div>
        </Grid>
        <Grid
          item
          onClick={(e) => this.handleClick(e, 1)}
          className="option-quantity-button"
        >
          <AddCircleOutline style={{ color: themeColor }} />
        </Grid>
      </Grid>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    usedComponents: state.store.used_components,
  };
};

export default connect(mapStateToProps)(ListQuantityBox);
